import React from 'react';

const PageHeader=(props)=>{	
	return (
		<div>
			{props.children}
		</div>
	);
}

export default PageHeader;